import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const api = "https://apideneme.com.tr/api";

const ShowUsers = () => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [showLinks, setShowLinks] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const menuRef = useRef(null);

    useEffect(() => {
        const userId = Cookies.get('user_id');
        if (userId !== "1") {
            setMessage("Admin değilsiniz. Yönlendiriliyorsunuz...");
            Cookies.remove('user_token');
            Cookies.remove('user_id');
            localStorage.removeItem('user_id');
            setTimeout(() => navigate('/'), 2000);
        } else {
            setIsAdmin(true);
            getAllUsers();
        }
    }, [navigate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowLinks(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleBack = () => {
        const userId = Cookies.get('user_id'); // Cookies'den al
        if (userId === "1") {
            navigate("/items"); // Adminse items sayfasına yönlendir
        } else {
            navigate("/user-items"); // Diğer kullanıcılar için user-items sayfasına yönlendir
        }
    };

    const getAllUsers = async () => {
        try {
            const userId = Cookies.get('user_id'); // Cookie'den user_id'yi al
            const response = await axios.get(`${api}/users`, {
                params: { user_id: userId } // user_id parametresi ile API isteğini gönder
            });
            console.log(response.data); // Gelen veriyi kontrol etmek için konsola yazdır
            const sortedUsers = response.data.sort((a, b) => a.id - b.id);
            setUsers(sortedUsers);
            setFilteredUsers(sortedUsers);
        } catch (error) {
            console.error("Kullanıcı verilerini alırken hata oluştu:", error);
        }
    };    

    const deleteUser = async (id) => {
        try {
            await axios.delete(`${api}/users/${id}`);
            getAllUsers();
        } catch (error) {
            console.error("Silme işlemi sırasında hata oluştu:", error);
            alert("Silme işlemi başarısız oldu. Lütfen tekrar deneyin.");
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        if (e.target.value === "") {
            setFilteredUsers(users);
        } else {
            const filtered = users.filter((user) =>
                user.id.toString().includes(e.target.value) ||
                user.name.toLowerCase().includes(e.target.value.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    };

    const handleAdminClick = () => {
        setShowLinks(!showLinks);
    };

    return (
        <div>
            {message && <div style={{ color: "red", fontWeight: "bold" }}>{message}</div>}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", marginBottom: "5px", marginTop: "5px" }}>
    <div style={{ boxShadow: "0 0 5px rgba(0, 123, 255, 0.5)", flexShrink: 0, marginLeft: "4px" }}>
        <input
            type="text"
            className="form-control"
            placeholder="Search by User ID or Name"
            value={searchTerm}
            onChange={handleSearch}
            style={{width: "200px", display: "inline-block" }} />
    </div>

    <div style={{ position: "relative" }}>
        <div style={{ 
            display: "flex", 
            justifyContent: "flex-end", 
            gap: "5px", 
            alignItems: "center" 
        }}>
            <button
                className="btn"
                style={{
                    marginRight: "5px",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    backgroundColor: "gray", // Gri renk
                    border: "none",
                    color: "white",
                    cursor: "pointer",
                    position: "relative",
                }}
                onClick={handleBack}
            >
                BACK
            </button>
        </div>
    </div>
</div>


            <table className="table table-striped">
                <thead className="bg-success text-white">
                    
                        <th>Id</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Action</th>

                </thead>
                <tbody>
                    {filteredUsers.map((user) => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.name || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{user.email || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>
                                <Link to={`/edit-user/${user.id}`} className="btn btn-warning" style={{ marginRight: "1px" }}>Edit</Link>
                                <button onClick={() => deleteUser(user.id)} className="btn btn-danger">Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ShowUsers;
